import React from 'react'

export function TextWork({className, content}) {
  return (
    <p className={className}>{content}</p>
  )
}
